import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Row, Column } from '@lux/components';

import { H1 } from '../Base';
import Spacing from '../Spacing';

import getYoutubeId from '../../helpers/getYoutubeId';

const StyledWrapper = styled.div`
  padding: ${p => p.theme.spacing(6)} 0;
  background-color: ${p => p.theme.colours.haze};
  border-top: 1px solid ${p => p.theme.colours.grey_400};

  ${p => p.theme.media.md`
    padding: ${p.theme.spacing(9)} 0;
    border: none;
  `};
`;

const StyledVideo = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const PhoneDetailsVideo = props => {
  const { title, videoUrl } = props;

  const videoId = getYoutubeId(videoUrl);

  return (
    <StyledWrapper data-testid="product-video">
      <Grid>
        <Row center="sm">
          <Column sm={12} md={8}>
            {title && (
              <Spacing bottom={3} bottomMd={5}>
                <H1>{title}</H1>
              </Spacing>
            )}
            <StyledVideo>
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                frameBorder={0}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </StyledVideo>
          </Column>
        </Row>
      </Grid>
    </StyledWrapper>
  );
};

PhoneDetailsVideo.propTypes = {
  title: PropTypes.string,
  videoUrl: PropTypes.string
};

export default PhoneDetailsVideo;
